<template>
  <div class="block">
    <div class="block-content">
      <div class="row">
        <div class="container">
          <p>{{ translate[lang]["customerwidgetdesc"] }}</p>
        </div>
        <div class="col-md-12">
          <h6>{{ translate[lang]["customerwidgetquestion"] }}</h6>
        </div>
        <div class="col-md-3 mb-3">
          <div class="utility">
            <input
              id="typeSelection1"
              type="radio"
              value="1"
              name="customer_type"
              v-model="form.data.customertype"
            />
            <label for="typeSelection1"
              ><img
                :src="getImage('/images/request/v2/particulier.png')"
              /><span>{{ translate[lang]["Particulier"] }}</span>
              <a
                data-toggle="modal"
                data-target="#moreinfo"
                class="more"
                style="z-index: 110;"
                @click="openModal()"
                >{{ translate[lang]["moreinfo"] }}</a
              >
            </label>
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="utility">
            <input
              id="typeSelection2"
              type="radio"
              value="2"
              name="customer_type"
              v-model="form.data.customertype"
            />
            <label for="typeSelection2"
              ><img :src="getImage('/images/request/v2/zakelijk.png')" /><span
                >{{ translate[lang]["Zakelijk"] }}</span
              >
              <a
                data-toggle="modal"
                data-target="#moreinfo"
                class="more"
                style="z-index: 110;"
                @click="openModal()"
                >{{ translate[lang]["moreinfo"] }}</a
              >
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerWidget",
  props: ["open"],
  methods: {
    openModal() {
      this.open({
        name: {
          en: "Name",
          nl: "Naam"
        },
        description: {
          en: "Description",
          nl: "Omschrijving"
        }
      });
    }
  }
};
</script>

<style scoped></style>
